/** 가챠 앱 공통 색상 — 디자인 시스템 토큰에 없는 앱 전용 값 */
export const BRAND_COLOR = '#ff5626'
export const SUB_COLOR = '#acaeb4'
